<template>
  <div>
    <h5 class="mb-5">Other Info</h5>
    <div>
      <b-table-simple bordered class="custom-table">
        <b-tbody>
          <b-tr>
            <b-td><strong>Funds AUM ( Rs crore )</strong></b-td>
            <b-td>₹ {{ otherInfo.aum || 'N/A' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Launch Date</strong></b-td>
            <b-td>{{ otherInfo.launchDate || 'N/A' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Minimum Investment</strong></b-td>
            <b-td>₹{{ otherInfo.minInvestment || 'N/A' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Fund Managers</strong></b-td>
            <b-td>{{ otherInfo.fundManagers || 'N/A' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Expense Ratio</strong></b-td>
            <b-td>
              {{
                otherInfo.expenseRatio != null
                  ? Number(otherInfo.expenseRatio).toFixed(2) + '%'
                  : 'N/A'
              }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Exit Load</strong></b-td>
            <b-td>{{ otherInfo.exitLoad || 'N/A' }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    formatNumber(value) {
      if (!value) return 'N/A'
      return Number(value).toLocaleString('en-IN')
    },
    formatCurrency(value) {
      if (!value) return 'N/A'
      return `₹ ${Number(value).toLocaleString('en-IN')}`
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      return `${day} - ${month} - ${year}`
    },
  },
  computed: {
    ...mapGetters(['schemeData']),
    otherInfo() {
      return {
        aum: this.formatNumber(
          Math.round(this.schemeData?.schemedetails?.scheme_aum)
        ),
        launchDate: this.formatDate(
          this.schemeData?.schemedetails?.launch_date
        ),
        expenseRatio: this.schemeData?.schemedetails?.expense_ratio,
        minInvestment: this.schemeData?.schemedetails?.min_investment,
        fundManagers: this.schemeData?.schemedetails?.fund_managers,
        exitLoad: this.schemeData?.schemedetails?.exit_load_remarks,
      }
    },
  },
}
</script>
<style scoped>
.custom-table {
  background: #ffffff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
</style>
